(function() {
  'use strict';

  var COOKIE_NAME = 'med_popup_shown';
  var COOKIE_DAYS = 7;
  var TIMER_DELAY = 8000;
  var DISCOUNT_CODE = 'WELCOME10';

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = name + '=' + value + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  if (getCookie(COOKIE_NAME)) return;

  var overlay = document.createElement('div');
  overlay.id = 'med-popup-overlay';
  overlay.innerHTML = '<div id="med-popup-modal">' +
    '<button id="med-popup-close" aria-label="Close">&times;</button>' +
    '<div id="med-popup-content">' +
    '<div id="med-popup-form-view">' +
    '<h2>Get 10% Off Your First Order</h2>' +
    '<p class="med-popup-sub">Plus free shipping on orders over $199. Join thousands of boaters who shop with us.</p>' +
    '<form id="med-popup-form">' +
    '<input type="email" id="med-popup-email" placeholder="Enter your email address" required autocomplete="email" />' +
    '<button type="submit" id="med-popup-cta">CLAIM MY 10% OFF</button>' +
    '</form>' +
    '<button id="med-popup-dismiss">No thanks, I\u2019ll pay full price</button>' +
    '</div>' +
    '<div id="med-popup-success-view" style="display:none">' +
    '<h2>Your Code Is Ready!</h2>' +
    '<p class="med-popup-sub">Use this code at checkout for 10% off your first order:</p>' +
    '<div id="med-popup-code">' + DISCOUNT_CODE + '</div>' +
    '<p class="med-popup-sub med-popup-small">Click the code to copy it to your clipboard.</p>' +
    '<button id="med-popup-shop" class="med-popup-cta-btn">START SHOPPING</button>' +
    '</div>' +
    '</div>' +
    '</div>';

  document.body.appendChild(overlay);

  function showPopup() {
    if (getCookie(COOKIE_NAME)) return;
    overlay.classList.add('med-popup-visible');
    document.body.style.overflow = 'hidden';
  }

  function hidePopup() {
    overlay.classList.remove('med-popup-visible');
    document.body.style.overflow = '';
    setCookie(COOKIE_NAME, '1', COOKIE_DAYS);
  }

  document.getElementById('med-popup-close').addEventListener('click', hidePopup);
  document.getElementById('med-popup-dismiss').addEventListener('click', hidePopup);
  overlay.addEventListener('click', function(e) { if (e.target === overlay) hidePopup(); });
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') hidePopup(); });

  var shopBtn = document.getElementById('med-popup-shop');
  if (shopBtn) shopBtn.addEventListener('click', hidePopup);

  document.getElementById('med-popup-form').addEventListener('submit', function(e) {
    e.preventDefault();
    var email = document.getElementById('med-popup-email').value.trim();
    if (!email) return;

    var ctaBtn = document.getElementById('med-popup-cta');
    ctaBtn.textContent = 'SUBSCRIBING...';
    ctaBtn.disabled = true;

    fetch('/contact#contact_form', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: 'form_type=customer&utf8=%E2%9C%93&customer%5Bemail%5D=' + encodeURIComponent(email) + '&customer%5Btags%5D=newsletter%2Cpopup-welcome10'
    }).catch(function() {});

    document.getElementById('med-popup-form-view').style.display = 'none';
    document.getElementById('med-popup-success-view').style.display = 'block';

    if (typeof gtag === 'function') {
      gtag('event', 'popup_subscribe', { method: 'welcome10' });
    }
  });

  var codeEl = document.getElementById('med-popup-code');
  if (codeEl) {
    codeEl.addEventListener('click', function() {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(DISCOUNT_CODE);
        var orig = codeEl.textContent;
        codeEl.textContent = 'COPIED!';
        setTimeout(function() { codeEl.textContent = orig; }, 1500);
      }
    });
  }

  setTimeout(showPopup, TIMER_DELAY);

  if (window.innerWidth > 768) {
    var exitFired = false;
    document.addEventListener('mouseout', function(e) {
      if (exitFired) return;
      if (e.clientY <= 0 && !getCookie(COOKIE_NAME)) {
        exitFired = true;
        showPopup();
      }
    });
  }
})();